import { render } from "./ControlMenuButton.vue?vue&type=template&id=72ea61b2"
import script from "./ControlMenuButton.vue?vue&type=script&lang=ts"
export * from "./ControlMenuButton.vue?vue&type=script&lang=ts"
script.render = render

export default script